import StakingComp from "components/stakingComp";
import React from "react";

const Staking = ({
  getUserNfts,
  getClaimedReward,
  getUserStaked,
  userBalance,
  userReward,
  staked,
  stakedDetail,
  userIds,
}) => {
  return (
    <div>
      <StakingComp
        getUserNfts={getUserNfts}
        getClaimedReward={getClaimedReward}
        getUserStaked={getUserStaked}
        userBalance={userBalance}
        userReward={userReward}
        staked={staked}
        stakedDetail={stakedDetail}
        userIds={userIds}
      />
    </div>
  );
};

export default Staking;
